import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay, faTrash } from "@fortawesome/free-solid-svg-icons";
import { tones } from "./constants";

const styles = {
    picker: { background: "#f1f3f5", borderRadius: 6, padding: 2 },
    button: { fontSize: 12, borderRadius: 4, padding: "3px 10px", border: 0 },
};

const shiftActionOptions = [
    { value: "open-shift", label: "move-to-open-shift", icon: faCalendarDay, permission: "canMove", tone: "primary" },
    { value: "delete", label: "delete", icon: faTrash, permission: "canDelete", tone: "danger" },
];

const ShiftActionPicker = ({ value, onChange, permissions }) => {
    const { t } = useTranslation();

    return (
        <div className="d-inline-flex" style={styles.picker}>
            {shiftActionOptions.filter((option) => permissions[option.permission]).map((option) => {
                const selected = value === option.value;
                return (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => onChange(option.value)}
                        className={classNames("d-inline-flex align-items-center", selected && "font-weight-bold shadow-sm")}
                        style={{
                            ...styles.button,
                            background: selected ? "#fff" : "transparent",
                            color: selected ? tones[option.tone].color : "#6c757d",
                            cursor: "pointer",
                        }}
                    >
                        <FontAwesomeIcon icon={option.icon} className="mr-1" />
                        {t(option.label)}
                    </button>
                );
            })}
        </div>
    );
};

export default ShiftActionPicker;
